export default {
  routes: [
    {
      name: 'modules',
      path: '/development/modules',
      component: () => import('./views/TheModules.vue')
    },
  ]
}
